<template>
  <div class="flex-col page">
    <div class="flex-col flex-auto group_2">
      <div class="flex-col group_3">
        <div class="flex-col items-start space-y-18">
          <div v-if="dataJson[2]" class="font_1 text_2">解决方案ID：{{dataJson[2].title}}</div>
          
          <swiper v-if="dataJson[3]" ref="mySwiper" :options="swiperOption" class="mySwiper" style="width: 350px;">
            <swiper-slide v-for="(item,index) of dataJson[3].word.split(',')" :key="index">
              <div class="imgWrap"><img class="image_6" :src="item"></div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>

        <div v-if="dataJson[4]" class="flex-row equal-division space-x-8">
          <div class="flex-col items-center equal-division-item space-y-12">
            <div class="flex-col justify-start items-center text-wrapper"><span class="font_2">🦠</span></div>
            <span class="font_3">包身除霉</span>
          </div>
          <div class="flex-col items-center equal-division-item space-y-12">
            <div class="flex-col justify-start items-center text-wrapper"><span class="font_2">🌬️</span></div>
            <span class="font_3">内衬除霉</span>
          </div>
        </div>

        <div v-if="dataJson[5]" class="flex-col group_4 view">
          <span class="self-start font_4">宝贝诊断</span>
          <div v-for="(item,index) of dataJson[5].title.split(',')" :key="index" class="flex-col group_5">
            <div class="flex-row items-start group_7 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 text-wrapper_2"><span class="font_6">🔍</span> </div>
              <span class="flex-auto font_7 text_3">{{ dataJson[5].word.split(',')[index] }}</span>
            </div>
            <div class="flex-row items-baseline relative group_6 space-x-6">
              <span class="font_5">{{ item }}</span>
            </div>
          </div>
        </div>

        <div class="flex-col group_11">
          <span class="self-start font_8">服务方式</span>
          <div v-if="dataJson[6]" class="flex-row items-center group_12 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">📦</span></div>
            <div class="flex-col items-start space-y-6">
              <span class="font_5">物流要求</span>
              <span class="font_9">{{ dataJson[6].title }}</span>
            </div>
          </div>
          <div v-if="dataJson[7]" class="flex-row items-center group_13 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">💰</span></div>
            <div class="flex-col items-start space-y-6">
              <span class="font_5">保价要求</span>
              <span class="font_9">{{ dataJson[7].title }}</span>
            </div>
          </div>
          <div v-if="dataJson[8]" class="flex-row items-center group_14 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">💼</span></div>
            <div class="flex-col items-start space-y-6">
              <span class="font_5">保险要求</span>
              <span class="font_9">{{ dataJson[8].title }}</span>
            </div>
          </div>
          <div v-if="dataJson[9]" class="flex-row items-center group_14 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">🕒</span></div>
            <div class="flex-col items-start space-y-6">
              <span class="font_5">周期要求</span>
              <span class="font_9">{{ dataJson[9].title }}</span>
            </div>
          </div>
          <div v-if="dataJson[10]" class="flex-row items-center group_14 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">🧶</span></div>
            <div class="flex-col items-start space-y-6">
              <span class="font_5">余料处理要求</span>
              <span class="font_9">{{ dataJson[10].title }}</span>
            </div>
          </div>

          <div v-if="dataJson[11]" class="flex-row items-center group_14 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">🧼</span></div>
            <div class="flex-col items-start space-y-6">
              <span class="font_5">材料要求</span>
              <span class="font_9">{{ dataJson[11].title }}</span>
            </div>
          </div>

          <span v-if="dataJson[12]" class="self-start font_8 text_5">服务保障</span>
          <div v-if="dataJson[12]" class="flex-row group_15 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_3"><span class="font_5">质保90天</span></div>
            <div class="flex-col justify-start text-wrapper_4"><span class="font_5 text_6">洗坏包赔</span></div>
            <div class="flex-col justify-start text-wrapper_4"><span class="font_5 text_7">丢件必赔</span></div>
          </div>
        </div>
        
        <div v-if="dataJson[13]" class="flex-col group_4 view_2">
          <span class="self-start font_10 text_8">{{ dataJson[13].title }}</span>
          <div class="flex-col group_16 space-y-4">
            <span class="self-start font_5 text_9">环境潮湿</span>
            <div class="flex-row group_17 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">🌧</span>
              </div>
              <span class="flex-auto font_7">
                包包处于潮湿的环境中时，容易吸收空气中的水分，导致发霉。
              </span>
            </div>
          </div>
          <div class="flex-col group_16 space-y-4">
            <span class="self-start font_5 text_9">有发霉环境</span>
            <div class="flex-row group_17 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">🦠</span>
              </div>
              <span class="flex-auto font_7">
                特别是在雨季或高湿度的天气条件下，有利于霉菌滋生和繁殖的条件。
              </span>
            </div>
          </div>
          <div class="flex-col group_16 space-y-4">
            <span class="self-start font_5 text_9">缺乏通风</span>
            <div class="flex-row group_17 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">💭</span>
              </div>
              <span class="flex-auto font_7">
                由于缺乏空气流通，导致湿气无法散发出去，从而形成了潮湿的环境。
              </span>
            </div>
          </div>
          <div class="flex-col group_16 space-y-4">
            <span class="self-start font_5 text_9">包包的材质</span>
            <div class="flex-row group_17 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">👛</span>
              </div>
              <span class="flex-auto font_7">
                吸湿性较强的材质，也可能受到霉菌的侵害。
              </span>
            </div>
          </div>
        </div>

        <div v-if="dataJson[14]" class="flex-col group_4 view_3">
          <span class="self-start font_10 text_16">{{dataJson[14].title}}</span>
          <div class="flex-col group_22 space-y-4">
            <span class="self-start font_5 text_17">保持干燥</span>
            <div class="flex-row group_23 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">🧪</span>
              </div>
              <span class="flex-auto font_7">
                可以将防潮剂、干燥剂和活性炭放置在包包内，但请确保它们的包装完整，没有破损，并且表面没有沾水。
              </span>
            </div>
          </div>
          <div class="flex-col group_22 space-y-4">
            <span class="self-start font_5 text_17">给包通风</span>
            <div class="flex-row group_23 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">🪟</span>
              </div>
              <span class="flex-auto font_7">
                放置在通风良好的地方，避免封闭或潮湿的环境。同时，要注意避免包包暴露在直接阳光下或过度阳光暴晒的环境中。
              </span>
            </div>
          </div>
          <div class="flex-col group_22 space-y-4">
            <span class="self-start font_5 text_17">存储位置</span>
            <div class="flex-row group_23 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">💼</span>
              </div>
              <span class="flex-auto font_7">
                通风性差的位置如墙壁或角落，不要放包。尽量放置在柜子中间位置，空气流通更好。
              </span>
            </div>
          </div>
          <div class="flex-col group_22 space-y-4">
            <span class="self-start font_5 text_17">按时检查</span>
            <div class="flex-row group_23 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">🧐</span>
              </div>
              <span class="flex-auto font_7">
                定期检查包包内部和外部，发现潮湿迹象时及时处理。
              </span>
            </div>
          </div>
          <div class="flex-col group_22 space-y-4">
            <span class="self-start font_5 text_17">轮换使用</span>
            <div class="flex-row group_23 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">🛍️</span>
              </div>
              <span class="flex-auto font_7">
                经常轮换使用包包，让它们得到休息和通风。
              </span>
            </div>
          </div>
          <div class="flex-col group_22 space-y-4">
            <span class="self-start font_5 text_17">定期保养</span>
            <div class="flex-row group_23 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">⏰</span>
              </div>
              <span class="flex-auto font_7">
                不仅可以延长包包寿命，还能及时发现问题。
              </span>
            </div>
          </div>
          <div class="flex-col group_22 space-y-4">
            <span class="self-start font_5 text_17">借助工具</span>
            <div class="flex-row group_23 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 self-start text-wrapper_5">
                <span class="font_11 text_10">🧰</span>
              </div>
              <span class="flex-auto font_7">
                使用吹风机的凉风模式，反复将风吹向潮湿的区域。请确保吹风机的温度不要过高，以避免包包变形。
              </span>
            </div>
          </div>
        </div>

        <div v-if="dataJson[15]||dataJson[16]" class="flex-col group_4 view_4">
          <span class="self-start font_4">除霉周边</span>
          <div v-if="dataJson[15]" class="flex-col group_8">
            <div class="flex-row items-start group_30 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 text-wrapper_2">
                <span class="font_6">👜</span>
              </div>
              <span class="flex-auto font_7 text_4">
                日常使用包包除霉清洁剂可以保持包包清洁、干爽，防止霉菌滋生。
              </span>
            </div>
            <span class="self-start font_5 text_22">包包除霉喷雾</span>
          </div>

          <div v-if="dataJson[16]" class="flex-col group_8">
            <div class="flex-row items-start group_30 space-x-8">
              <div class="flex-col justify-start items-center shrink-0 text-wrapper_2">
                <span class="font_6">🧪</span>
              </div>
              <span class="flex-auto font_7 text_4">
                防潮除湿剂可以吸收空气中的湿气，保持环境干燥，预防霉菌滋生，日常使用效果更佳。
              </span>
            </div>
            <span class="self-start font_5 text_22">防潮除湿剂</span>
          </div>
        </div>

        <div v-if="dataJson[17]" class="flex-col group_31">
          <span class="self-start font_10 text_23">{{dataJson[17].title}}</span>

          <div v-for="(item,index) of dataJson[17].word.split(',')" :key="index" class="flex-row items-center group_13 space-x-8" style="border-top: none;">
            <div class="flex-col justify-start items-center text-wrapper_2">
              <span v-if="item.indexOf('全新专柜价')!=-1" class="font_6">✌️</span>
              <span v-if="item.indexOf('全新未使用')!=-1" class="font_6">👍</span>
              <span v-if="item.indexOf('几乎全新')!=-1" class="font_6">👌</span>
              <span v-if="item.indexOf('轻微使用痕迹')!=-1" class="font_6">😔</span>
              <span v-if="item.indexOf('明显使用痕迹')!=-1" class="font_6">😓</span>
            </div>
            <div class="flex-col items-start space-y-8">
              <span class="font_5">{{item.split('¥')[0]}}</span>
              <span class="font_12">¥{{item.split('¥')[1]}}</span>
            </div>
          </div>

          
          <span class="font_1 text_24">注：以上行情价格结果是根据各平台历史销售等综合数据得出</span>
        </div>

        <div v-if="dataJson[18]" class="flex-col group_4 view_5">
          <span class="self-start font_4">服务权益</span>
          <span class="self-start font_5 text_26" style="margin-top: 14px;">服务费 ¥299/季度，享6大权益：</span>
          <div class="flex-row items-center group_33 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">✍🏻</span></div>
            <div class="flex-col items-start space-y-6">
              <span class="font_5">定制化服务</span>
              <span class="font_9">按你的偏好进行各种定制</span>
            </div>
          </div>
          <div class="flex-row items-center group_13 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">🧑🏻‍💼</span></div>
            <div class="flex-col items-start space-y-8">
              <span class="font_5">1V1管家</span>
              <span class="font_12 text_25">管家就是你的私人助理</span>
            </div>
          </div>
          <div class="flex-row items-center group_14 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">🤑</span></div>
            <div class="flex-col items-start space-y-6">
              <span class="font_5">平价服务</span>
              <span class="font_9 text_26">提供几近成本价的服务</span>
            </div>
          </div>
          <div class="flex-row items-center group_14 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">🔎</span></div>
            <div class="flex-col space-y-6">
              <span class="self-start font_5">全面咨询</span>
              <!-- <div class="flex-row space-x-6">
                <span class="font_9">包包 5个</span>
                <span class="font_9">鞋靴 10双</span>
                <span class="font_9">衣服 10件</span>
                <span class="font_9">配饰 10个</span>
                <span class="font_9">鉴定不限</span>
              </div> -->
              <span class="font_9 text_26">可支持宝贝全方位答疑</span>
            </div>
          </div>
          <div class="flex-row items-center group_14 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">👀</span></div>
            <div class="flex-col items-start space-y-6">
              <span class="font_5">过程透明</span>
              <span class="font_9 text_26">透明服务方便可视</span>
            </div>
          </div>
          <div class="flex-row items-center group_14 space-x-8">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">ℹ️</span></div>
            <div class="flex-col items-start space-y-6">
              <span class="font_5">信息服务</span>
              <span class="font_9 text_26">实用建议帮你解决问题</span>
            </div>
          </div>
        </div>

        <div v-if="dataJson[19]" class="flex-col group_4 view_6">
          <span class="self-start font_4">费用明细</span>
          <div v-for="(item,index) of dataJson[19].title.split(',')" :key="index" class="flex-row items-center group_13 space-x-8" style="border-top: none;">
            <div class="flex-col justify-start items-center text-wrapper_2"><span class="font_6">✅</span></div>
            <div class="flex-col items-start space-y-8">
              <span class="font_5">{{ item.split('¥')[0] }}</span>
              <span class="font_12 text_27">¥{{ item.split('¥')[1] }}</span>
            </div>
          </div>
        </div>

      </div>

      <div v-if="dataJson[20]" class="flex-col justify-start items-start text-wrapper_7"><span class="text_29">合计：{{ dataJson[20].title }}</span></div>

      <div class="flex-col group_36 space-y-32">
        <span v-if="dataJson[21]" class="self-start font_4 text_30">{{ dataJson[21].title }}为你提供定制</span>
        <div @click="closeWindow" class="flex-col justify-start items-center button"><span class="font_4 text_31">联系管家预约</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import wxShare from "@/assets/js/wx.share"
import {swiper, swiperSlide} from 'vue-awesome-swiper'
export default {
  name: 'customPageIndex',
  components:{swiper,swiperSlide},
  data() {
    return {
      dataJson: {
        // 1: '喵森的包包除霉定制方案', // 名称
        // 2: '000001', // 方案ID
        // 3: 'https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/646731e55a7e3f0310c3e445/646732a354fe00001163132b/16844852181714432350.png', // 物品图片
        // 4: 'https://codefun-proj-user-res-1256085488.cos.ap-guangzhou.myqcloud.com/646731e55a7e3f0310c3e445/646732a354fe00001163132b/16844852181714432350.png', // 症状卡片
        // 5: '', // 服务项
        // 6: '', // 症状
        // 7: '', // 增值服务
        // 8: '', // 增值服务
        // 9: '', // 增值服务
        // 10: '', // 增值服务
        // 11: '', // 服务保障
        // 12: '', // TIPS
        // 13: '', // TIPS
        // 14: '', // 周边
        // 15: '', // 周边
        // 16: '', // 行情信息
        // 17: '', // 会员权益
        // 18: '', // 定制师
        // 19: '', // 费用
        // 20: '', // 费用
        // 21: '', // 底部按钮
      },
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      screens: [],
      pointsTracked: [], // 记录已经追踪的埋点
      zhugeName: '除霉定制方案gpt'
    };
  },

  created() {
    let dataObj = {}
    console.log(location.href.length)
    if(location.search.indexOf('?')!=-1) {
      let searchStr = decodeURIComponent(location.search.split('?')[1])
      let arr = searchStr.split('&')
      console.log('arr',arr)
      arr.map(item=>{
        let key = item.split('=')[0]
        let value = item.split('=')[1]
        if(key == 'modules') {
          value.split(',').map(item2=>{
            console.log('item2',item2)
            dataObj[item2] = true
          })
        }
        for(let i = 1; i<=21;i++) {
          if(key == ('m'+i)) {
            dataObj[i] = JSON.parse(value)
          }
        }
      })
    }
    console.log('dataObj',dataObj)
    this.dataJson = dataObj
  },

  mounted() {
    this.$nextTick(() => {
      if(this.dataJson[1]) {
        document.title = this.dataJson[1].title
      }
    })
    setTimeout(()=>{
      let shareBody = {
        title : '包拯',
        desc : '从此以后你不是一个人在操心',
        link: window.location.href,
        imgUrl:'https://baozheng-nice-new.baozheng.cc/uploads/content/file/data/000/000/097/4452b221.jpg'
      };
      if(this.dataJson[1]) {
        shareBody.title = this.dataJson[1].title
      }
      if(this.dataJson[3]) {
        shareBody.imgUrl = this.dataJson[3].word.split(',')[0]
      }
      console.log('shareBody',shareBody)
      wxShare(shareBody);
    },100)
    this.$nextTick(() => {
      const screenHeight = window.innerHeight;
      const pageHeight = document.body.clientHeight;
      const numScreens = Math.ceil(pageHeight / screenHeight);

      for (let i = 0; i < numScreens; i++) {
        this.screens.push((i + 1) * screenHeight);
      }
      zhuge.track(`${this.zhugeName}-第1屏曝光(共${this.screens.length}屏)`)
    });

    window.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      const screenHeight = window.innerHeight;
      const pageHeight = document.body.clientHeight;

      if (scrollPosition + screenHeight >= pageHeight - screenHeight / 10 && !this.pointsTracked.includes('bottom')) {
        // 用户已经滑动到页面底部，执行埋点操作
        this.pointsTracked.push('bottom');
        console.log('用户已经滑动到页面底部')
        zhuge.track(`${this.zhugeName}-页面完全曝光(共${this.screens.length}屏)`)
      } else {
        for (let i = 1; i < this.screens.length; i++) {
          const screenEnd = this.screens[i];
          const screenStart = i > 0 ? this.screens[i - 1] : 0;
          const screenHeight = screenEnd - screenStart;

          if (scrollPosition >= screenStart && scrollPosition < screenStart + screenHeight / 3 && !this.pointsTracked.includes(`screen${i}`)) {
            // 用户滑动到第 i 屏的 1/3 处，执行埋点操作
            this.pointsTracked.push(`screen${i}`);
            console.log(`用户滑动到第 ${i+1} 屏`)
            zhuge.track(`${this.zhugeName}-第${i+1}屏曝光(共${this.screens.length}屏)`)
          }
        }
      }
    },

    closeWindow() {
      zhuge.track(`${this.zhugeName}-点击底部按钮`)
      WeixinJSBridge.call('closeWindow');
      //  window.history.back();
    }
  },
}
</script>

<style scoped lang="scss">
/************************************************************
** 请将全局样式拷贝到项目的全局 CSS 文件或者当前页面的顶部 **
** 否则页面将无法正常显示                                  **
************************************************************/

html {
  font-size: 16px;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',
    'Droid Sans', 'Helvetica Neue', 'Microsoft Yahei', sans-serif;
}

body * {
  box-sizing: border-box;
  flex-shrink: 0;
}

#app {
  width: 100vw;
  height: 100vh;
}

.flex-row {
  display: flex;
  flex-direction: row;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.justify-evenly {
  justify-content: space-evenly;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.items-baseline {
  align-items: baseline;
}

.items-stretch {
  align-items: stretch;
}

.self-start {
  align-self: flex-start;
}

.self-end {
  align-self: flex-end;
}

.self-center {
  align-self: center;
}

.self-baseline {
  align-self: baseline;
}

.self-stretch {
  align-self: stretch;
}

.flex-1 {
  flex: 1 1 0%;
}

.flex-auto {
  flex: 1 1 auto;
}

.grow {
  flex-grow: 1;
}

.grow-0 {
  flex-grow: 0;
}

.shrink {
  flex-shrink: 1;
}

.shrink-0 {
  flex-shrink: 0;
}

.relative {
  position: relative;
}
.page {
  background-color: #ffffff;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  .header {
    background-color: #ffffff;
    height: 88px;
    .section {
      padding: 5px 8px;
      background-color: #ffffff;
      .image {
        margin-right: 2px;
        width: 18px;
        height: 14px;
      }
      .image_2 {
        margin-right: 9px;
        width: 14px;
        height: 14px;
      }
      .image_3 {
        margin-right: 8px;
        width: 9px;
        height: 14px;
      }
      .image_4 {
        width: 34px;
        height: 10px;
      }
    }
    .group {
      padding: 24px 12px;
      .image_5 {
        width: 24px;
        height: 24px;
      }
      .pos {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
      }
      .text {
        color: #000000e6;
        font-size: 18px;
        font-family: Roboto;
        line-height: 16.5px;
      }
    }
  }
  .group_2 {
    padding-bottom: 22px;
    overflow-y: auto;
    .group_3 {
      padding: 4px 10px 0 12px;
      .space-y-18 {
        & > *:not(:first-child) {
          margin-top: 18px;
        }
        .text_2 {
          margin-left: 4px;
        }
        .imgWrap{
          width: 350px;
          height: 350px;
        }
        .image_6 {
          border-radius: 6px;
          width: 100%;
          height: 100%;
        }
      }
      .equal-division {
        margin-right: 2px;
        margin-top: 20px;
        .equal-division-item {
          flex: 1 1 164px;
          padding: 4px 0 12px;
          border-radius: 6px;
          height: 88px;
          border: solid 1px #0000001a;
          .text-wrapper {
            padding: 8px 0;
            background-color: #f0f0f0;
            border-radius: 24px;
            width: 48px;
            .font_2 {
              font-size: 32px;
              font-family: Roboto;
              line-height: 32px;
              color: #000000de;
            }
          }
          .font_3 {
            font-size: 10px;
            font-family: Roboto;
            line-height: 9px;
            color: #000000de;
          }
        }
        .space-y-12 {
          & > *:not(:first-child) {
            margin-top: 12px;
          }
        }
      }
      .space-x-8 {
        & > *:not(:first-child) {
          margin-left: 8px;
        }
      }
      .group_4 {

        .group_5 {
          margin-top: 6px;
          padding: 12px 0 6px;
          height: 68px;
          border-bottom: solid 1px #0000001a;
          .group_7 {
            margin-right: 12px;
            margin-top: 8px;
          }
          .group_6 {
            margin-top: -48px;
            padding: 0 40px;
          }
        }
        .group_8 {
          margin-top: 6px;
          padding: 12px 0 6px;
          height: 68px;
          border-bottom: solid 1px #0000001a;
          .group_10 {
            margin-right: 12px;
            margin-top: 8px;
          }
          .group_9 {
            margin-top: -48px;
            padding: 0 42px;
          }
          .group_30 {
            margin-right: 10px;
            margin-top: 8px;
          }
          .text_22 {
            margin-left: 42px;
            margin-top: -48px;
          }
        }
        .font_7 {
          font-size: 12px;
          font-family: Roboto;
          line-height: 16px;
          color: #00000080;
        }
        .space-x-6 {
          & > *:not(:first-child) {
            margin-left: 6px;
          }
        }
        .text_8 {
          line-height: 17px;
        }
        .group_16 {
          margin-top: 14px;
          padding-bottom: 6px;
          border-bottom: solid 1px #0000001a;
          .text_9 {
            margin-left: 40px;
          }
          .group_17 {
            margin-right: 4px;
          }
        }
        .space-y-4 {
          & > *:not(:first-child) {
            margin-top: 4px;
          }
        }
        .group_18 {
          margin-top: 6px;
          padding: 12px 0 6px;
          height: 69px;
          border-top: solid 1px #0000001a;
          border-bottom: solid 1px #0000001a;
          .group_19 {
            margin-right: 16px;
            margin-top: 8px;
          }
          .text_11 {
            margin-left: 40px;
            margin-top: -48px;
          }
          .group_24 {
            margin-right: 12px;
            margin-top: 8px;
          }
        }
        .text-wrapper_5 {
          padding: 6px 0 11px;
          background-color: #f0f0f0;
          border-radius: 24px;
          width: 32px;
          height: 32px;
          .text_10 {
            line-height: 14.5px;
          }
          .text_12 {
            line-height: 14.5px;
          }
          .text_19 {
            line-height: 14px;
          }
        }
        .text_4 {
          margin-top: 8px;
        }
        .group_20 {
          padding: 10px 0 8px;
          height: 67px;
          .group_21 {
            margin-right: 24px;
            margin-top: 8px;
          }
          .text_13 {
            margin-left: 40px;
            margin-top: -48px;
          }
          .group_27 {
            margin-right: 12px;
            margin-top: 8px;
            .text_20 {
              margin-top: 8px;
            }
          }
        }
        .font_11 {
          font-size: 20px;
          font-family: Roboto;
          line-height: 15px;
          color: #7f7f7f;
        }
        .text_16 {
          line-height: 17px;
        }
        .group_22 {
          margin-top: 14px;
          padding-bottom: 6px;
          border-bottom: solid 1px #0000001a;
          .text_17 {
            margin-left: 40px;
          }
          .group_23 {
            margin-right: 10px;
          }
        }
        .group_25 {
          padding: 10px 0 8px;
          height: 68px;
          border-bottom: solid 1px #0000001a;
          .group_26 {
            margin-right: 10px;
            margin-top: 8px;
          }
          .text_18 {
            margin-left: 40px;
            margin-top: -48px;
          }
        }
        .text-wrapper_6 {
          padding: 6px 0 10px;
          background-color: #f0f0f0;
          border-radius: 24px;
          width: 32px;
          height: 32px;
          .text_14 {
            line-height: 14.5px;
          }
        }
        .text_15 {
          margin-top: 8px;
        }
        .group_28 {
          margin-top: 16px;
          height: 49px;
          border-bottom: solid 1px #0000001a;
          .group_29 {
            padding-bottom: 6px;
            margin-right: 12px;
            margin-top: 8px;
          }
          .text_21 {
            margin-left: 40px;
            margin-top: -48px;
          }
        }
        .text_3 {
          margin-top: 8px;
        }
        .group_33 {
          margin-top: 16px;
        }
        .group_34 {
          padding: 10px 0 8px;
        }
        .group_35 {
          margin-top: 16px;
        }
      }
      .view {
        margin-top: 22px;
      }
      .group_11 {
        margin-top: 26px;
        .font_8 {
          font-size: 16px;
          font-family: Roboto;
          line-height: 15px;
          color: #000000e6;
        }
        .group_12 {
          margin-top: 16px;
        }
        .text_5 {
          margin-top: 14px;
        }
        .group_15 {
          margin-top: 12px;
          .text-wrapper_3 {
            padding: 12px 0;
            background-color: #f5f5f5;
            border-radius: 6px;
            width: 74px;
            height: 36px;
          }
          .text-wrapper_4 {
            padding: 12px 0;
            background-color: #f5f5f5;
            border-radius: 6px;
            height: 36px;
            .text_6 {
              margin-left: 8px;
              margin-right: 6px;
            }
            .text_7 {
              margin-left: 8px;
              margin-right: 2px;
            }
          }
        }
      }
      .text-wrapper_2 {
        padding: 4px 0 8px;
        background-color: #f0f0f0;
        border-radius: 24px;
        width: 32px;
        height: 32px;
        .font_6 {
          font-size: 20px;
          font-family: Roboto;
          line-height: 20px;
          color: #000000de;
        }
      }
      .font_5 {
        font-size: 14px;
        font-family: Roboto;
        line-height: 13px;
        color: #000000e6;
      }
      .view_2 {
        margin-top: 38px;
      }
      .view_3 {
        margin-top: 26px;
      }
      .view_4 {
        margin-top: 26px;
      }
      .group_31 {
        margin-top: 26px;
        .text_23 {
          line-height: 17px;
        }
        .group_32 {
          margin-top: 14px;
        }
        .text_24 {
          margin-left: 6px;
          margin-top: 16px;
        }
      }
      .font_10 {
        font-size: 16px;
        font-family: Roboto;
        line-height: 16px;
        color: #000000de;
      }
      .group_13 {
        margin-top: 6px;
        padding: 12px 0 6px;
        border-top: solid 1px #0000001a;
        border-bottom: solid 1px #0000001a;
      }
      .group_14 {
        padding: 10px 0 8px;
        border-bottom: solid 1px #0000001a;
      }
      .space-y-6 {
        & > *:not(:first-child) {
          margin-top: 6px;
        }
        .font_9 {
          font-size: 12px;
          font-family: Roboto;
          line-height: 11px;
          color: #00000080;
        }
        .text_26 {
          line-height: 10px;
        }
      }
      .font_1 {
        font-size: 12px;
        font-family: Roboto;
        line-height: 11px;
        color: #7f7f7f;
      }
      .view_5 {
        margin-top: 20px;
      }
      .space-y-8 {
        & > *:not(:first-child) {
          margin-top: 8px;
        }
        .font_12 {
          font-size: 12px;
          font-family: Roboto;
          line-height: 9px;
          color: #00000080;
        }
        .text_25 {
          line-height: 8.5px;
        }
        .text_27 {
          line-height: 8.5px;
        }
        .text_28 {
          line-height: 8.5px;
        }
      }
      .view_6 {
        margin-top: 26px;
      }
    }
    .text-wrapper_7 {
      margin-top: 12px;
      padding: 10px 0 14px;
      border-radius: 8px;
      overflow: hidden;
      .text_29 {
        margin-left: 12px;
        color: #000000de;
        font-size: 24px;
        font-family: Roboto;
        line-height: 22px;
      }
    }
    .group_36 {
      padding: 14px 12px;
      .text_30 {
        color: #1a1a1a;
      }
      .button {
        padding: 12px 0 14px;
        background-color: #000000;
        border-radius: 8px;
        .text_31 {
          color: #ffffff;
        }
      }
    }
    .space-y-32 {
      & > *:not(:first-child) {
        margin-top: 32px;
      }
    }
    .font_4 {
      font-size: 16px;
      font-family: Roboto;
      line-height: 15px;
      color: #000000de;
    }
  }
}
</style>